const lazyObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    // temporarily disable lazy loading - together with Locomotive Scroll looks janky
    if (!entry.isIntersecting) return

    const img = entry.target
    const attrsToCheck = ['src', 'srcset']

    attrsToCheck.forEach(attr => {
      if (img.dataset[attr] && !img[attr]) {
        img[attr] = img.dataset[attr]
      }
      lazyObserver.unobserve(img)
    })
  })
})

const initLazyImage = root => {
  root
    .querySelectorAll('img[data-lazy-image]')
    .forEach(img => lazyObserver.observe(img))
}

export default initLazyImage
